import { useState } from 'react';
import { initialsFromName } from '@/lib/initials';
import { cn } from '@/utils/cn';

export type ClinicLogoBadgeTone = 'current' | 'active' | 'inactive';

function initialsToneClass(tone: ClinicLogoBadgeTone): string {
  switch (tone) {
    case 'current':
    case 'active':
      return 'bg-ds-teal text-ds-on-accent';
    case 'inactive':
      return 'bg-ds-neutral-tint text-ds-muted';
    default: {
      const _exhaustive: never = tone;
      return _exhaustive;
    }
  }
}

export function ClinicLogoBadge({
  name,
  logoSrc,
  initialsTone = 'current',
}: {
  name: string;
  logoSrc: string | null | undefined;
  initialsTone?: ClinicLogoBadgeTone;
}) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showLogo = Boolean(logoSrc) && failedSrc !== logoSrc;

  if (showLogo && logoSrc) {
    return (
      <span className="logo-plate flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden">
        <img
          src={logoSrc}
          alt={name}
          className="h-full w-full object-contain"
          onError={() => setFailedSrc(logoSrc)}
        />
      </span>
    );
  }

  return (
    <span
      className={cn(
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-ctl text-[13px] font-semibold',
        initialsToneClass(initialsTone),
      )}
    >
      {initialsFromName(name)}
    </span>
  );
}
